<template>
  <div id="UAV_system">
    <div class="font">
      <span class="introSubTitle"><b>自主研制轻小型无人机机巢</b></span>
      <p class="textStyle">已完成三代轻小型机巢研发，适配大疆御3等机型，可远程控制起飞、按规划路径飞行采集数据、降落、充电、回传数据，三维建模，树障分析等。长宽高：110*80*50cm，体积：小于0.45m³，重量：小于30-40kg，已集成微型气象站，可配置空调，可配置太阳能独立供电系统，特点是性价比高、可定制、轻量化。获得科技部国家遥感中心无人机第二届无人机遥感比测第一名，已经在中国南方电网有限责任公司超高压输电公司柳州局、百色局，长江流域生态环境监测与科学研究中心等多个单位应用。</p>
    </div>
 <!--    <br/>      -->
    
    <img width="100%" src="@/assets/img/scientific/UAVsystem1.jpg" />
<!--          <p class="img_figure">轻小型无人机机巢</p>          -->
    <img width="100%" src="@/assets/img/scientific/UAVsystem2.jpg" />
<!--      <p class="img_figure">航线规划</p>         -->
    <!-- <div class="container">
      <my-video :sources="video.sources" :options="video.options"></my-video>
    </div> -->
  </div>
</template>

<script>
// import myVideo from "vue-video";

export default {
  data() {
    return {
      // video: {
      //   sources: [
      //     {src: require("@/assets/static/Quick_change.mp4"), type:"video/mp4"},
      //   ],
      //   options: {
      //     autoplay: true,
      //     volume: 0.6,
      //   },
      // },
    };
  },
  // components: {
  //   myVideo,
  // },
};
</script>

<style lang="less">
#UAV_system {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #4f4f4f;
  }
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
